import { render, staticRenderFns } from "./ExploreHeader.vue?vue&type=template&id=3dc0bf7d"
import script from "./ExploreHeader.vue?vue&type=script&lang=js"
export * from "./ExploreHeader.vue?vue&type=script&lang=js"
import style0 from "./ExploreHeader.vue?vue&type=style&index=0&id=3dc0bf7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports